import { useMemo, useState } from "react";
import {
  Container, Row, Col, Button, Form, Table,
  Nav, Badge, Dropdown, Image
} from "react-bootstrap";


import Header from "../../components/header";
import Footer from "../../components/footer";


const MOCK_USERS = [
  {
    id: 1,
    name: "sajith devan",
    email: "kssajithdevan@gmail.com",
    phone: "",
    online: true,
    role: "ADMINISTRATOR",
    teams: "All Teams",
    avatar: "https://ui-avatars.com/api/?name=S+D&background=3ddc97&color=fff"
  }
];

export default function UsersInfo() {
  const [tab, setTab] = useState("users");
  const [q, setQ] = useState("");

  const users = useMemo(() => {
    return MOCK_USERS.filter(
      u =>
        `${u.name} ${u.email} ${u.phone} ${u.role} ${u.teams}`
          .toLowerCase()
          .includes(q.toLowerCase())
    );
  }, [q]);

  return (
      <div className="min-vh-100 d-flex flex-column">
    {/* Top Navbar */}
    <Header/>
      <section className="hero">
    <Container fluid className="py-4 bg-light min-vh-100">
      {/* Top bar */}
      <Row className="align-items-center g-2 mb-3">
        <Col xs={12} md="auto">
          <Nav
            variant="pills"
            activeKey={tab}
            onSelect={(k) => setTab(k || "users")}
            className="bg-white rounded-3 p-1 shadow-sm"
          >
            <Nav.Item><Nav.Link eventKey="users">Users</Nav.Link></Nav.Item>
            <Nav.Item><Nav.Link eventKey="teams">Teams</Nav.Link></Nav.Item>
          </Nav>
        </Col>

        <Col xs={12} md className="order-3 order-md-2">
          <Form.Control
            placeholder="Search…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </Col>

        <Col xs="auto" className="ms-md-auto order-2 order-md-3 d-flex gap-2">
          <Button variant="outline-secondary">Watch Tutorial</Button>
          <Button variant="success">Add User</Button>
        </Col>
      </Row>

      {/* Users table */}
      {tab === "users" && (
        <div className="bg-white rounded-3 p-2 shadow-sm">
          <Table hover responsive="md" className="mb-0 align-middle">
            <thead className="text-muted">
              <tr>
                <th style={{ width: 40 }}>
                  <Form.Check type="checkbox" />
                </th>
                <th>User</th>
                <th className="d-none d-md-table-cell">Online Status</th>
                <th className="d-none d-lg-table-cell">Email/Phone</th>
                <th className="d-none d-lg-table-cell">Role</th>
                <th className="d-none d-xl-table-cell">Teams</th>
                <th className="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.length === 0 ? (
                <tr>
                  <td colSpan={7} className="py-5 text-center text-muted">No users found.</td>
                </tr>
              ) : (
                users.map(u => (
                  <tr key={u.id}>
                    <td><Form.Check type="checkbox" /></td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <Image
                          src={u.avatar}
                          roundedCircle
                          width={36}
                          height={36}
                          alt={u.name}
                        />
                        <div className="lh-sm">
                          <div className="fw-semibold">{u.name}</div>
                          <div className="text-muted small d-md-none">{u.email}</div>
                        </div>
                      </div>
                    </td>
                    <td className="d-none d-md-table-cell">
                      <Badge bg="success" pill>{u.online ? "Online" : "Offline"}</Badge>
                    </td>
                    <td className="d-none d-lg-table-cell">
                      {u.email || <span className="text-muted">—</span>}
                      {u.phone ? <div className="small text-muted">{u.phone}</div> : null}
                    </td>
                    <td className="d-none d-lg-table-cell">{u.role}</td>
                    <td className="d-none d-xl-table-cell">{u.teams}</td>
                    <td className="text-end">
                      <Dropdown align="end">
                        <Dropdown.Toggle variant="outline-secondary" size="sm">⋯</Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item>Edit</Dropdown.Item>
                          <Dropdown.Item>Reset Password</Dropdown.Item>
                          <Dropdown.Divider />
                          <Dropdown.Item className="text-danger">Remove</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      )}

      {/* Teams placeholder */}
      {tab === "teams" && (
        <div className="bg-white rounded-3 p-4 shadow-sm text-center text-muted">
          Teams view coming next—list, members, and permissions.
        </div>
      )}

      {/* Footer */}
      <Row className="mt-2 align-items-center">
        <Col className="text-muted small">
          Rows per page: <span className="ms-2 fw-semibold">5</span>
        </Col>
        <Col className="text-end small text-muted">
          1–1 of 1
          <Button variant="link" className="text-decoration-none ms-3">Previous</Button>
          <Button variant="link" className="text-decoration-none">Next</Button>
        </Col>
      </Row>
    </Container>
      </section>
      {/* Footer Note */}
      <Footer/>
    </div>
  );
}
